import dayjs from 'dayjs';

import {
  preparerStatusConfig,
  reviewerStatusConfig,
} from 'utils/task-config/taskStatusConfig';

import { ChecklistTaskInstance } from 'types/checklist-v2/ChecklistTask';
import { TaskActorStatus, TaskActorType } from 'types/task/TaskCommon';
import { TaskInstanceActor } from 'types/task/TaskInstance';

export const findActorById = (
  task: ChecklistTaskInstance,
  role: TaskActorType,
  assigneeId: string
): TaskInstanceActor | undefined => {
  const collection = role === 'preparer' ? task.preparers : task.reviewers;
  return collection.find((actor) => actor.user_id === assigneeId);
};

export const getAssigneeStatusText = (
  actorType: TaskActorType,
  status?: string
): string => {
  const statusConfig =
    actorType === 'preparer' ? preparerStatusConfig : reviewerStatusConfig;
  return status && status in statusConfig
    ? statusConfig[status as TaskActorStatus].text
    : '—';
};

export const getDueDateText = (dueDate?: string): string => {
  return dueDate && dayjs(dueDate).isValid()
    ? dayjs(dueDate).format('ll')
    : '—';
};
